export class ExtraBlacklistDTO {
  constructor({ extraId, etabId } = {}) {
    this.etabId = etabId;
    this.extraId = extraId;
  }

  prepareData() {
    return {
      etab_id: this.etabId,
      extra_id: this.extraId,
    };
  }
}
